import { Middleware } from "redux";
import { RootState } from "../../../state";
import { serverRequest } from "../../../actions/app/api";
import { APP_URL, GET } from "../../../../_shared/constants";
import { GET_PROJECT } from "../../../actions";

export const getProject: Middleware<unknown, RootState> =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    if (action.type === GET_PROJECT.START) {
      const { id, payload, onFinish, ...rest } = action.meta;
      dispatch(
        serverRequest({
          method: GET,
          url: `${APP_URL.project.get}/${id}`,
          onFinish,
          payload,
          onSuccess: GET_PROJECT.SUCCESS,
          ...rest,
        })
      );
    }
  };
